import KpiApprovePage from "./KpiApprovePage";

export default KpiApprovePage